import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/images/modelIcon_gs.png'


const _hoisted_1 = { class: "scene-selection-content" }
const _hoisted_2 = { class: "scene-list-container" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "scene-item-title" }
const _hoisted_6 = { class: "model-footer" }

import { ref, computed, onMounted, onUnmounted, watch, nextTick, PropType,getCurrentInstance, onBeforeMount } from 'vue';
import {StationItem} from '@/types/baseInterFace'
import {$config,$enum} from '@/global/index'
import { saveUserTrainingSetting } from '@/service'
import {useStore} from 'vuex'


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  currentScene: {
    type: [String, Number],
    default: ''
  },
  query: {
    // 接口查询参数
    type: String,
    default: ''
  },
  list: {
    // 场景列表
    type: Array as PropType<StationItem[]>,
    default: () => []
  },
  sceneTypeId: {
    type: String,
    default: ''
  },
  loading: {
    type: Boolean,
    default: false
  }
},
  emits: ['close', 'confirm'],
  setup(__props, { emit: __emit }) {

const props = __props
const store = useStore()
const { proxy } = getCurrentInstance()!
const currentStationId = ref(store.state.persistence.userTrainSettingInfo.currentStationId)
const currentStationIndex = ref(-1)

watch(()=>props.currentScene, (newVal) => {
    currentStationId.value = newVal
})

watch(()=>props.loading, (newVal) => {
  if(confirmLoading.value !== newVal){
    confirmLoading.value = newVal
  }
})

const emit = __emit

const confirmLoading = ref(false)

const handleClose = () => {
    window?.playClick()
    emit('close')
}
const handleConfirm = async () => {
    window?.playClick()
    confirmLoading.value = true
    const {code, data, message} = await saveUserTrainingSetting({
      userId: store.state.persistence.userInfo.userId,
      tenantId: store.state.persistence.currentTenantId,
      sceneTypeId: props.sceneTypeId,
      stationId: currentStationId.value || props.list[0]?.stationId,
    })
    if(code !== $enum.EnumResult.SUCCESS || !data){
      proxy?.vknMessage.error('选择场地失败,请稍后重试')
      return;
    }
    if(!currentStationId.value){
      currentStationIndex.value = 0
    }else{
      store.commit('persistence/setUserTrainingSetting', {
        ...store.state.persistence.userTrainSettingInfo,
        currentStationId: currentStationId.value,
      })
      currentStationIndex.value = props.list.findIndex(item=>item.stationId == currentStationId.value)
    }
    emit('confirm', currentStationIndex.value)
}

const handleClick = (index:number,stationId:string) => {
  window?.playClick()
  currentStationId.value = stationId
  currentStationIndex.value = index
}

onBeforeMount(()=>{
    if(props.list && props.list.length > 0){
        currentStationIndex.value = props.list.findIndex(item=>item.stationId == currentStationId.value)
    }
})

return (_ctx: any,_cache: any) => {
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_vkn_button = _resolveComponent("vkn-button")!
  const _component_vkm_modal = _resolveComponent("vkm-modal")!

  return (_openBlock(), _createBlock(_component_vkm_modal, {
    title: "选择场地",
    onOnClose: handleClose
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_scrollbar, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.list, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass([currentStationId.value == item.stationId?'active-scene-item':'','scene-item']),
                  key: index,
                  onClick: ($event: any) => (handleClick(index,item.stationId))
                }, [
                  _createElementVNode("img", {
                    class: "scene-img",
                    src: `${_unref($config).FILE_ROOT_PATH}${item.scenePictureUrl}`,
                    alt: ""
                  }, null, 8, _hoisted_4),
                  _cache[0] || (_cache[0] = _createElementVNode("img", {
                    class: "model-icon",
                    src: _imports_0,
                    alt: ""
                  }, null, -1)),
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("span", null, _toDisplayString(item.stationName), 1)
                  ])
                ], 10, _hoisted_3))
              }), 128))
            ])
          ]),
          _: 1
        })
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_vkn_button, {
          label: "取消",
          type: "info",
          size: "medium",
          onClick: handleClose
        }),
        _createVNode(_component_vkn_button, {
          label: "进入",
          type: "primary",
          size: "medium",
          onClick: handleConfirm,
          loading: confirmLoading.value
        }, null, 8, ["loading"])
      ])
    ]),
    _: 1
  }))
}
}

})